import {
    Image,
    Link, TabPanel, Text, VStack,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { ComponentProps } from 'react';
import { NonIdealState } from '@acp/core-ui';
import { brandIcons } from '@acp/core-ui/assets';
import { UrgentActiveNoticeRow, UrgentActiveNoticeRowSkeleton } from './urgent-active-notice-row';
import { useUrgentActiveNotices } from './use-urgent-active-notices';

export function UrgentActiveNoticesTab({
    propertyManagerId,
    ...props
}: {
    propertyManagerId?: string;
} & ComponentProps<typeof TabPanel>) {
    const { data, isLoading } = useUrgentActiveNotices({
        propertyManagerId,
    });

    return (
        <TabPanel as={VStack} alignItems="stretch" p={0} pt={2} gap={4} {...props}>
            {
                data?.items !== undefined && data?.total > 0 && (
                    <Text>
                        There are issues preventing us from servicing one or more properties.
                        As services are now overdue, resolving access issues is urgent.
                    </Text>
                )
            }
            <VStack alignItems="center" justifyContent="center" gap={4}>
                {
                    data?.items.map(
                        (notice) => (
                            <UrgentActiveNoticeRow key={notice.id} notice={notice} />
                        )
                    )
                }
                {
                    data?.items !== undefined && data?.total === 0
                    && (
                        <NonIdealState
                            iconComponent={<Image src={brandIcons.noActiveNotice} />}
                            title="No properties with access issues"
                            description="You are all up to date!"
                            py={24}
                        />
                    )
                }
                {
                    isLoading && (
                        (
                            Array.from({ length: 10 }).map((_, index) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <UrgentActiveNoticeRowSkeleton key={index} />
                            ))
                        )
                    )
                }
            </VStack>
            {
                (
                    data?.items !== undefined
                    && data?.total > data?.items.length
                    && propertyManagerId === undefined
                ) && (
                    <Link as={RouterLink} to="/portfolio?facet=ACTIVE_NOTICES">
                        View all properties with access issues
                    </Link>
                )
            }
            {
                (
                    data?.items !== undefined
                    && data?.total > data?.items.length
                    && propertyManagerId !== undefined
                ) && (
                    <Link as={RouterLink} to={`/portfolio?facet=ACTIVE_NOTICES&property-manager=${propertyManagerId}`}>
                        View all properties with access issues
                    </Link>
                )
            }
        </TabPanel>
    );
}
